/* custom-effects.js — VesaroBlue
   Upload to Assets and include before </body>:
   <script src="{{ 'custom-effects.js' | asset_url }}"></script>
*/

/* small helper: add class when element enters viewport */
(function(){
  if (!('IntersectionObserver' in window)) {
    // fallback: simply add visible immediately
    document.querySelectorAll('.vb-fade, .vb-slide-left, .vb-slide-right').forEach(function(el){ el.classList.add('is-visible'); });
    return;
  }

  const io = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        // if you want one-time trigger, unobserve:
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });

  document.querySelectorAll('.vb-fade, .vb-slide-left, .vb-slide-right').forEach(el => io.observe(el));
})();

/* optional: simple menu toggle helper (if your theme uses .vb-menu and toggler .vb-menu-btn) */
(function(){
  const btn = document.querySelector('.vb-menu-btn');
  const menu = document.querySelector('.vb-menu');
  if (!btn || !menu) return;
  btn.addEventListener('click', function(e){
    e.preventDefault();
    menu.classList.toggle('vb-open');
  });
})();

/* small accessibility helper: open external links in new tab (used earlier) */
/* If you already have similar script, skip this */
(function(){
  const links = document.querySelectorAll('a[href]');
  links.forEach(l => {
    try {
      const url = new URL(l.href, location.href);
      if (url.hostname !== location.hostname) {
        l.setAttribute('target','_blank');
        l.setAttribute('rel','noopener noreferrer');
      }
    } catch(e){}
  });
})();
